var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6642 11.3784L10.9662 2.96132C10.8918 2.89714 10.7968 2.86121 10.6967 2.86121H8.42492C8.23496 2.86121 8.14768 3.09737 8.29143 3.22058L17.2809 11.0242H2.25907C2.14612 11.0242 2.05371 11.1166 2.05371 11.2295V12.7697C2.05371 12.8826 2.14612 12.975 2.25907 12.975H17.2784L8.28887 20.7786C8.14512 20.9044 8.23239 21.138 8.42235 21.138H10.7711C10.8199 21.138 10.8687 21.12 10.9046 21.0867L20.6642 12.6208C20.7531 12.5435 20.8243 12.4481 20.8731 12.3409C20.922 12.2338 20.9472 12.1174 20.9472 11.9996C20.9472 11.8818 20.922 11.7654 20.8731 11.6583C20.8243 11.5511 20.7531 11.4557 20.6642 11.3784Z",
    fill: "url(#paint0_linear_3402_718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3402_718",
    x1: 11.5521,
    y1: 21.2373,
    x2: 11.5521,
    y2: 2.8612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2054E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C62FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrowRight);
export default __webpack_public_path__ + "static/media/blueArrowRight.35ed55ac7e2f11428af06f3abe5a5f17.svg";
export { ForwardRef as ReactComponent };